import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { editLocation } from 'actions/provider';
import Button from 'atoms/button';
import { HourBlocks } from 'organisms/HourBlocks';
import { formatApiHours } from 'pages/Profile/util';
import { formatWebsite, prettifyHoursData } from 'util';

export default function BusinessHoursBlock() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const locationForm = useSelector((state) => state.locationForm);
  const provider = useSelector((state) => state.provider);
  const location = provider.locations[0];

  const [hours, setHours] = useState({
    Monday: {},
    Tuesday: {},
    Wednesday: {},
    Thursday: {},
    Friday: {},
    Saturday: {},
    Sunday: {},
  });

  useEffect(() => {
    setHours(formatApiHours(location.hours, hours));
  }, []);

  const onNext = async (e) => {
    e.preventDefault();

    const res = await dispatch(
      editLocation({
        ...locationForm,
        name: provider.name,
        countryCodeId:
          locationForm.countryCodeId.id || locationForm.countryCodeId.code.id,
        website: formatWebsite(locationForm.website),
        hours: prettifyHoursData(hours),
      })
    );
    if (res.success) navigate('/signup-4');
  };

  return (
    <div className="business-info">
      <form onSubmit={onNext}>
        <HourBlocks hours={hours} setHours={setHours} />
        <Button className="mt-32 mb-30" type="submit" text="Next" />
      </form>
    </div>
  );
}
